<template>
  <div class="product">
    <figure class="product-image">
      <img :src="`https://imagecdn.shiseido.co.jp/c/a=0,f=webp:jpeg/resources/sw${item.shohin_pl_c_gz_ir_fl_pth}`" :alt="`${item.shohin_name}`" loading="lazy" />
    </figure>
    <div class="product-main">
      <div class="product-top">
        <p class="product-name" v-text="`${item.brnd_mei} ${item.shohin_name}`" />
        <p class="product-reco">
          <span class="product-reco-text">おすすめ度</span>
          <part-star
            :ten="toInteger(Number(item.heikin_hyoka), false)"
            :one="toInteger(Number(item.heikin_hyoka), true)"
          />
          <span class="product-reco-num" v-text="visibleRecommendation" />
        </p>
      </div>

      <div class="product-bottom" :class="[{'is-long-type': isLongType}, {'is-middle-type': isMiddleType}]">
        <p class="product-info-text">
          <span class="product-info-type" v-text="category" />
          <span class="product-info-size" v-text="item.hyoji_yo_naiyo_ryo" />
        </p>

        <div class="product-info">
          <p class="product-info-price">
            <span class="product-info-number" v-text="visiblePrice" />
            <span class="product-info-unit">円（税込）</span>
          </p>

          <p class="product-link">
            <a :href="`https://www.shiseido.co.jp/sw/c/products/SWFG070410.seam?shohin_pl_c_cd=${item.shohin_pl_c_cd}`" target="_blank">商品詳細を見る</a>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import toInteger from '@/modules/toInteger.js';
import partStar from './partStar.vue';

export default {
  components: { partStar },
  name: 'SortResultProduct2',
  props: {
    item: {
      type: Object
    },
  },
  computed: {
    isLongType() {
      return this.category + this.item.hyoji_yo_naiyo_ryo >= 20;
    },
    isMiddleType() {
      return this.category + this.item.hyoji_yo_naiyo_ryo > 10 && this.category + this.item.hyoji_yo_naiyo_ryo < 20;
    },
    category() {
      return this.item.yakuji_kbn_mei === '' ? `（医薬部外品）${this.item.birui_mei}` : `＜${this.item.birui_mei}＞`
    },
    visiblePrice() {
      return Number(this.item.komi_kkk).toLocaleString();
    },
    visibleRecommendation() {
      return Number(this.item.heikin_hyoka) === 0 ? '評価しない' : Number(this.item.heikin_hyoka).toFixed(1);
    }
  },
  methods: {
    toInteger
  }
}
</script>

<style lang="scss" scoped>
.product {
  margin: 20/295 * 100% 0 -5/295 * 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @include media () {
    margin: 30px 0 10px;
  }
  &-image {
    width: 60/295 * 100%;
    @include media() {
      width: 100px;
    }
  }
  &-main {
    display: contents;
    @include media() {
      display: block;
      width: calc(100% - 120px);
    }
  }
  &-top {
    width: 225/295 * 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    @include media() {
      width: 100%;
    }
  }
  &-name {
    text-align: left;
    font-size: 12/375 * 100vw;
    font-weight: bold;
    line-height: (18/12);
    letter-spacing: .05em;
    @include media() {
      font-size: 16px;
    }
  }
  &-reco {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 3/375 * 100vw;
    @include media() {
      margin-top: 7px;
    }
    &-text {
      margin-right: 3/375 * 100vw;
      font-size: 11/375 * 100vw;
      line-height: 1;
      @include media() {
        margin-right: 4px;
        font-size: 12px;
      }
    }
    &-num {
      font-family: Arial;
      margin-left: 3/375 * 100vw;
      font-size: 14/375 * 100vw;
      font-weight: bold;
      line-height: 1;
      @include media() {
        margin-left: 3px;
        font-size: 14px;
      }
    }
  }
  &-bottom {
    width: 100%;
    margin: 0 0 0;
    &.is-middle-type,
    &.is-long-type {
      flex-wrap: wrap;
    }
    &.is-middle-type {
      align-items: flex-end;
    }
    @include media() {
      display:flex;
      align-items: center;
      justify-content: space-between;
      margin: 5px 0 0;
    }
  }
  &-info {
    font-size: 11/375 * 100vw;
    line-height: (16/11);
    display:flex;
    align-items: end;
    justify-content: space-between;

    .is-long-type & {
      display: contents;
    }
    .is-middle-type & {
      width: calc(100% - 25vw);
      @include media() {
        width: auto;
      }
    }
    @include media() {
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex:1;
    }
    &-text {
      margin-top:10/295 * 100%;
      margin-bottom:4/295 * 100%;
      display: block;
      @include media() {
        margin-right: .25em;
        margin-top:0;
        margin-bottom:0;
      }
    }
    &-type {
      //white-space: nowrap;
      margin-right: 0.25em;
      .is-middle-type & {
        // display: block;
      }
    }
    &-price {

      .is-middle-type & {
        display: block;
        @include media() {
          display: inline;
        }
      }
    }
    &-number {
      display: inline-block;
      margin: 5/375 * 100vw 3/375 * 100vw 0 6/375 * 100vw;
      font-family: Arial;
      font-size: 16/375 * 100vw;
      line-height: 1;
      font-weight: bold;
      letter-spacing: .08em;
      @include media() {
        margin: 0 2px 0 4px;
        font-size: 20px;
        letter-spacing: .1em;
      }
    }
  }
  &-link {
    margin-left: auto;
    min-width: 90/375 * 100vw;
    font-size: 10/375 * 100vw;
    line-height: 1;
    letter-spacing: .03em;
    white-space: nowrap;



    @include media() {
      width: 160px;
      min-width:160px;
      font-size: 12px;
      letter-spacing: .1em;
    }
    .is-long-type & {
      margin-top: 5/375 * 100vw;
      margin-bottom: 5/375 * 100vw;
      @include media() {
        margin-top: 0;
        margin-bottom: 0;
      }
    }
    a {
      display: block;
      padding: 6/375 * 100vw 8/375 * 100vw;
      border-radius: 12/375 * 100vw;
      text-align: center;
      background: #DF0168;
      color: #fff;
      text-decoration: none;

      @include media() {
        padding: 14px 0;
        border-radius: 20px;
        transition: .45s ease;
        &:hover {
          letter-spacing: .3em;
        }
      }
    }
  }
}
</style>